import React from 'react'

import { ShareOutlined } from '@mui/icons-material'
import { useSelector } from 'react-redux'

import Button from '../../../../../../../../../../shared/components/Button/Button.component'
import ShareOfferRequestLinkModal from '../../../../../../../../../../shared/components/ShareOfferRequestLinkModal/ShareOfferRequestLinkModal.component'

import { RootState } from '../../../../../../../../../../redux/store/store.types'
import ModalFunctions from '../../../../../../../../../../shared/components/Modal/Modal.functions'
import status from '../../../../../../../../../../shared/functions/Status/status.dictionaries'
import useResponsiveness from '../../../../../../../../../../shared/hooks/responsive.hooks'
import { ShareOfferButtonProps } from './ShareOfferButton.types'

const ShareOfferButton: React.FC<ShareOfferButtonProps> = (props) => {
  const { offerRequestId, itemRequests } = props
  const [isDesktop] = useResponsiveness()

  const { success: offerRequestsSuccess } = useSelector((state: RootState) => state.getAllOfferRequestsForAdmin)

  const offerRequest = offerRequestsSuccess?.data?.records.find((offerRequest) => offerRequest.id === offerRequestId)

  const isOfferRequestCancelled =
    offerRequest?.status?.name === status.itemRequestStatus.cancelledByShopper ||
    offerRequest?.status?.name === status.offerRequestStatus.cancelled_by_admin

  // Could also check if connected to a flight and booked but for admin we don't need to check that,
  // when they open the link they should be blocked selecting the offer.

  const getTooltipText = () => {
    if (isOfferRequestCancelled) {
      return 'Cannot share cancelled offer'
    }

    return 'Share offer request link'
  }

  const handleShareClick = () => {
    if (!offerRequestId || !offerRequest?.shopper?.id) return

    const shareLink = `${window.location.origin}/offers?offerRequestIds=${offerRequestId}&shopperId=${offerRequest?.shopper.id}`
    const sourceCountry = itemRequests?.[0]?.item?.country

    if (!sourceCountry) return

    ModalFunctions.show({
      title: 'Share Offer Request',
      body: <ShareOfferRequestLinkModal sourceCountry={sourceCountry} shareLink={shareLink} open={true} />,
      primaryButton: {
        label: 'Close',
        onClick: () => ModalFunctions.close()
      }
    })
  }

  return (
    <Button
      text={isDesktop ? 'Share Link' : undefined}
      buttonType="secondary"
      icon={<ShareOutlined />}
      disabled={isOfferRequestCancelled}
      onClick={handleShareClick}
      tooltipText={getTooltipText()}
    />
  )
}

export default ShareOfferButton
